import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-customer-param',
  templateUrl: './modify-customer-param.component.html',
  styleUrls: ['./modify-customer-param.component.css']
})
export class ModifyCustomerParamComponent implements OnInit {

  editForm: any | FormGroup
  paramData:any = []
  customerId: any = "";
  cid:any
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getCustomerParams()
    this.editForm = this.fb.group({
      name: [''],
    })  
  }

  updateCustomerParams(){

      let body = {
        "id":this.customerId,
        "name": String(this.editForm.get('name').value),
        "version": 0,
        "isActive": true,
        "description": "string",
        "cid": this.cid
      }

    console.log(body)
    this.generic_service.updateCustomerParams(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getCustomerParams()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getCustomerParams(){
    this.generic_service.getCustomerParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getCustomerParamsById(id:any){
    this.customerId = id
    this.generic_service.getCustomerParamsById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }



}
